<template>
  <div class="boxOne">
    <div class="topitems">
      <div class="flex">
        <div class="items ">
          <div class="btnbox dn-content-bg">
            <el-button type="primary" size="small" style="margin-left:30px" @click="createKPIGroup('add')">添加KPI组</el-button>
            <el-button type="success" size="small" style="margin-left:30px" @click="createKPIGroup('edit')">编辑KPI组</el-button>
            <el-button type="info" size="small" style="margin-left:30px" @click="deleteKPIGroup()">删除KPI组</el-button>
            <el-button type="primary" size="small" style="margin-left:30px" @click="actionUsing()">操作usingKPI</el-button>
          </div>
          <div class="tablebox dn-content-bg t">
            <div class="tbbox table-warp">
              <!-- border -->
              <el-table height="100%" border ref="kpiGroupData" :data="kpiGroupData" highlight-current-row @current-change="handleCurrentChangekpiGroup" style="width: 100%">
                <template v-for="(item, index) in kpiGroupColumns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'"></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
        <div class="items2 dn-content-bg">
          <div class="btnbox">
            <el-form label-width="50px">
              <el-button type="primary" size="small" style="margin-left:30px" @click="addKPI('add')">新增KPI</el-button>
              <el-button type="success" size="small" style="margin-left:30px" @click="addKPI('edit')">编辑KPI</el-button>
              <el-button type="info" size="small" style="margin-left:30px" @click="deleteKPI()">删除KPI</el-button>
              <el-button type="primary" size="small" style="margin-left:30px" @click="addKPIValue('add')">新增KPI Value</el-button>
              <el-button type="success" size="small" style="margin-left:30px" @click="addKPIValue('edit')">编辑KPI Value</el-button>
              <el-button type="info" size="small" style="margin-left:30px" @click="deleteKPIValue()">删除KPI Value</el-button>
            </el-form>
          </div>
          <div class="tablebox tablebox">
            <div class="tbbox table-warp" ref="rightTableBox">
              <el-table border height="100%" ref="kpiData" :data="kpiData" highlight-current-row :span-method="arraySpanMethod" @current-change="handleCurrentChangeFl" style="width: 100%">
                <template v-for="(item, index) in kpicolumns">
                  <el-table-column v-if="item.show != false" :key="index" :prop="item.prop" :label="item.label" :align="item.align?item.align:'center'"></el-table-column>
                </template>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- kpi組弹窗 -->
    <el-dialog :title="titlekpiGroup" :visible.sync="kpiGroupDig" width="500px" :close-on-click-modal="false" @close="formClosekpiGroup">
      <el-form label-width="100px" :model="kpiGroupForm" :rules="rules" style="text-align: left;" ref="kpiGroupForm">
        <!-- :inline-message="true" -->
        <el-form-item label="名称:" prop="name" style="height:50px" class="nc">
          <el-input v-model="kpiGroupForm.name" style="width:200px" placeholder="请输入名称" autocomplete="off" clearable></el-input>
        </el-form-item>
        <el-form-item label="显示名称:" prop="displayName" class="nc">
          <el-input v-model="kpiGroupForm.displayName" placeholder="请输入显示名称" autocomplete="off" clearable></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-right:190px">
        <el-button type="primary" @click="saveKpiGroup" class="btn">保 存</el-button>
        <el-button @click="kpiGroupDig = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- usingkpi組弹窗 -->
    <el-dialog :title="usingKPITiltle" :visible.sync="usingKPI" width="700px" style="text-align: left;" :close-on-click-modal="false">
      <el-button type="primary" @click="usingAdd" class="btn">新增</el-button>
      <div style="height: 250px;overflow: auto;margin: 5px 0;">
        <el-table id="table" :data="usingTable" border height="100%" highlight-current-row size="small" :header-cell-style="tableHeaderColor">
          <el-table-column prop="measureName" sortable label="测量点" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="expressionName" sortable label="测量点表达式名称" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column prop="expressionDisplayName" sortable label="显示名称" :show-overflow-tooltip="true" align="center"></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <el-button @click="usingModify(scope.row)" type="text" size="small">编辑</el-button>
              <el-button type="text" size="small" @click="usingDele(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer" style="margin-right:340px">
        <el-button type="primary" @click="usingKPI=false" class="btn">保 存</el-button>
        <el-button @click="usingKPI = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- usingKPI编辑弹窗 -->
    <el-dialog :title="addUsingKPITitle" :visible.sync="usingUp" width="500px" :close-on-click-modal="false">
      <div>
        <div>
          <label class="usingTitle">测量点表达式名称:</label>
          <el-select v-model="expressionName" placeholder="请选择" class="usingItem">
            <el-option v-for="item in expressData" :key="item.name" :label="item.displayName" :value="item.name"></el-option>
          </el-select>
        </div>

      </div>
      <div slot="footer" class="dialog-footer" style="margin-right:190px">
        <el-button type="primary" @click="saveUsing" class="btn">保 存</el-button>
        <el-button @click="usingUp = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- usingKPI新增弹窗 -->
    <el-dialog :title="addUsingKPITitle" :visible.sync="usingAdd1" width="900px" :close-on-click-modal="false">
      <div style="text-align:left;width:100%;height:600px">
        <!-- MesureTree -->
        <measure-tree :isClick="usingAdd1" @saveUsing="saveUsing" @close="close" v-if="usingAdd1"></measure-tree>
      </div>

      <!-- <div slot="footer"
           class="dialog-footer"
           style="margin-right:190px">
        <el-button type="primary"
                   @click="saveUsing"
                   class="btn">保 存</el-button>
        <el-button @click="usingAdd1 = false"
                   class="cancel">取 消</el-button>
      </div> -->
    </el-dialog>
    <!-- api弹窗 -->
    <el-dialog :title="titleKpi" :visible.sync="kpiDig" width="500px" :close-on-click-modal="false" @close="formClosekpi">
      <el-form label-width="100px" :model="kpiForm" style="text-align: left;" :rules="rules" ref="kpiForm">
        <el-form-item label="名称:" prop="name" class="nc">
          <el-input v-model="kpiForm.name" placeholder="请输入名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="显示名称:" prop="displayName" class="nc">
          <el-input v-model="kpiForm.displayName" placeholder="请输入显示名称" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-right:190px">
        <el-button type="primary" @click="saveKpi" class="btn">保 存</el-button>
        <el-button @click="kpiDig = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- api value弹窗 -->
    <el-dialog :title="titleKpiValue" :visible.sync="kpiValueDig" width="650px" :close-on-click-modal="false" @close="formClosekpiValue">
      <el-form label-width="100px" :model="kpiValueForm" :rules="rules" style="text-align:left" ref="kpiValueForm">
        <el-form-item label="时间:">
          <el-date-picker v-model="search.dates" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :unlink-panels="true" align="right"></el-date-picker>
        </el-form-item>
        <el-form-item label="上限值:" class="nc" prop="upperBound">
          <el-input v-model="kpiValueForm.upperBound" placeholder="请输入上限值" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="下限值:" class="nc" prop="lowerBound">
          <el-input v-model="kpiValueForm.lowerBound" placeholder="请输入下限值" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="margin-right:190px">
        <el-button type="primary" @click="saveKpiValue" class="btn">保 存</el-button>
        <el-button @click="kpiValueDig = false" class="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as utils from '@/utils/index.js'
import { isNull, isUndefined } from 'util'
import dateTool from "@/utils/dateTool";
import { getPage } from '@/utils/index.js'
import MeasureTree from './pages/measureTree.vue'
export default {
  name: 'kpigl',
  components: { MeasureTree },
  data () {
    var check = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('名称不能为空'))
      } else {
        const reg = /[\da-zA-Z_]+/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入字母,下划线或数字'))
        }
      }
    }
    var checkNumber = (rule, value, callback) => {
      if (value === '') {
        return callback(new Error('不能为空'))
      } else {
        const reg = /^(-?\d+)(\.\d+)?$/ //数字
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('只能为数字'))
        }
      }
    }
    return {
      kpiGroupData: [], //kpi組數據
      kpiData: [],
      kpiValueData: [],
      kpiGroupColumns: [
        //KPI组
        // { prop: "id", label: "id", show: true,align:"left" },
        { prop: 'name', label: '名称', show: true, align: 'left' },
        { prop: 'displayName', label: '显示名称', show: true, align: 'left' },
      ],
      kpicolumns: [
        //kpi信息
        // { prop: "id", label: "id", show: true,align:"left" },
        { prop: 'name', label: 'KPI名称', show: true, align: 'left' },
        { prop: 'displayName', label: '显示名称', show: true, align: 'left' },
        { prop: 'upperBound', label: '上限值', show: true, align: 'left' },
        { prop: 'lowerBound', label: '下限值', show: true, align: 'left' },
        { prop: 'startTime', label: '开始时间', show: true, align: 'left' },
        { prop: 'endTime', label: '结束时间', show: true, align: 'left' },
      ],
      selectKpiGroup: {}, //选择kpi组
      selectKpi: {}, //选择kpi
      selectKpiValue: {}, //选择kpiValue
      kpiGroupForm: {
        //kpi组
        name: '',
        displayName: '',
        id: '',
      },
      kpiForm: {
        //kpi
        id: '',
        name: '',
        displayName: '',
      },
      kpiValueForm: {
        //kpiValue
        id: '',
        startTime: '',
        endTime: '',
        lowerBound: '',
        upperBound: ''
      },
      titlekpiGroup: '新增kpi组',
      titleKpi: '新增',
      titleKpiValue: '新增',
      rules: {
        name: [
          { validator: check, trigger: ['blur', 'change'], required: true },
        ],
        displayName: [
          {
            required: true,
            message: '请输入显示名称',
            trigger: ['blur', 'change'],
          },
        ],
        value: [
          {
            validator: checkNumber,
            trigger: ['blur', 'change'],
            required: true,
          },
        ],
        upperBound: [
          {
            validator: checkNumber,
            trigger: ['blur', 'change'],
            required: true,
          },
        ],
        lowerBound: [
          {
            validator: checkNumber,
            trigger: ['blur', 'change'],
            required: true,
          },
        ],
      },
      kpiGroupDig: false, //kpi组
      kpiDig: false, //kpi组
      kpiValueDig: false,
      search: {
        //计量新增时间段
        dates: [],
      },
      usingKPITiltle: '操作usingKPI',
      usingKPI: false,
      usingTable: [],
      addUsingKPITitle: '新增',
      usingAdd1: false,
      usingUp: false,
      expressionName: '',
      measureId: '',
      viewsData: [],
      usingKpiId: null,
      expressData: [],
    }
  },
  created () { },
  watch: {
    async measureId (newVal, oldVal) {
      if (newVal !== '') {
        let resTwo = await this.$api.measure.getUniqueMeasuresExpressions(JSON.stringify([newVal]))  //获取表达式数据
        this.expressData = resTwo.data[0].expressionGroups[0].expression
      }
    }
  },
  mounted () {
    this.getKPIGroup2()
  },
  methods: {
    //查询KPI组
    getKPIGroup2 () {
      let vm = this
      vm.$api.kpi
        .getKPIGroup2(this.$store.state.user.currentCompanyId)
        .then((res) => {
          vm.kpiGroupData = res.data
          vm.kpiGroupForm.id = res.data[0].id
          if (Object.keys(vm.selectKpiGroup).length > 0) {
            let setCurrentRowXh = vm.kpiGroupData.find((obj) => {
              return obj.id == vm.selectKpiGroup.id
            })
            if (setCurrentRowXh) {
              vm.$refs.kpiGroupData.setCurrentRow(setCurrentRowXh) //选中某行  新的
              vm.kpiGroupForm.id = vm.selectKpiGroup.id //旧的
            } else {
              vm.$refs.kpiGroupData.setCurrentRow(vm.kpiGroupData[0]) //选中第一行 新的
            }
          } else {
            vm.$refs.kpiGroupData.setCurrentRow(vm.kpiGroupData[0]) //选中第一行 新的
          }
          this.getKPI2(vm.kpiGroupForm.id)
        })
        .catch((error) => {
          vm.$message.error(error.data.errorStr)
        })
    },
    //kpi组选择行
    handleCurrentChangekpiGroup (row) {
      let vm = this
      row = isNull(row) ? {} : row
      if (Object.keys(row).length > 0) {
        vm.selectKpiGroup = row
        vm.getKPI2(vm.selectKpiGroup.id)
      }
    },
    //新增编辑kpi组
    createKPIGroup (type) {
      let vm = this
      vm.kpiGroupForm.name = ''
      vm.kpiGroupForm.displayName = ''
      this.search = {
        //计量编辑时间段
        dates: [],
      }
      if (type == 'add') {
        vm.titlekpiGroup = '新增kpi組'
      } else {
        if (Object.keys(vm.selectKpiGroup).length == 0) {
          vm.$message({
            message: '请选择你要编辑的kpi組！',
            type: 'warning',
          })
          return
        }
        vm.titlekpiGroup = '编辑kpi組'
        vm.kpiGroupForm.name = vm.selectKpiGroup.name
        vm.kpiGroupForm.displayName = vm.selectKpiGroup.displayName
      }
      vm.kpiGroupDig = true
    },
    //新增编辑kpi组保存
    saveKpiGroup () {
      let vm = this
      vm.$refs['kpiGroupForm'].validate((valid) => {
        if (valid) {
          let backres = []
          if (vm.titlekpiGroup == '新增kpi組') {
            backres = [vm.$api.kpi.createKPIGroup(
              this.$store.state.user.currentCompanyId,
              vm.kpiGroupForm.name,
              vm.kpiGroupForm.displayName
            )]
          } else {
            backres = [vm.$api.kpi.modifyKPIGroup(
              vm.selectKpiGroup.id,
              vm.kpiGroupForm.name,
              vm.kpiGroupForm.displayName
            )]
          }
          Promise.all(backres)
            .then((resArr) => {
              const res = resArr[0]
              if (res.success) {
                if (vm.titlekpiGroup == '新增kpi组') {
                  vm.$message.success('新增成功！')
                } else {
                  vm.$message.success(res.msg)
                }
                vm.kpiGroupDig = false
                vm.getKPIGroup2()
              } else {
                return
              }
            })
            .catch((error) => {
              vm.$message.error(error.data.errorStr)
            })
        } else {
          return false
        }
      })
    },
    //删除kpi组
    deleteKPIGroup () {
      let vm = this
      if (Object.keys(vm.selectKpiGroup).length == 0) {
        vm.$message({
          message: '请选择你要删除的kpi分组！',
          type: 'warning',
        })
        return
      }
      vm.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          vm.$api.kpi.deleteKPIGroup(vm.selectKpiGroup.id).then((res) => {
            if (res.success) {
              vm.getKPIGroup2() ////
              vm.selectKpiGroup = {}
              vm.$message.success(res.msg)
            }
          })
        })
        .catch((error) => {
          vm.$message.error(error.data.errorStr)
        })
    },
    //actionUsing
    async actionUsing () {
      if (Object.keys(this.selectKpiGroup).length == 0) {
        this.$message({
          message: '请选择你要操作的kpi分组！',
          type: 'warning',
        })
        return
      }
      this.usingKPI = true
      this.getUsingKPIByGroupId()
    },
    /* 查询usingKPI */
    async getUsingKPIByGroupId () {
      let resOne = await this.$api.kpi.getUsingKPIByGroupId(this.selectKpiGroup.id)//获取usingKPI数据
      let resExpress = null
      if (resOne) {
        if (resOne.data.length > 0) {
          this.usingTable = resOne.data[0].usingInfo
        } else {
          this.usingTable = []
        }
      }
    },
    /* 新增usingKPI */
    async usingAdd () {
      this.usingAdd1 = true
      this.addUsingKPITitle = '新增'
      this.expressionName = ''
      this.measureId = ''
      let res = await this.$api.measure.getViewableMeasures(this.$store.state.user.currentCompanyId)
      if (res) {
        this.viewsData = res.data
      }
    },
    //编辑usingKPI
    usingModify (row) {
      this.usingUp = true
      this.addUsingKPITitle = '编辑'
      this.usingKpiId = row.id
      this.measureId = row.measureId
      this.expressionName = row.expressionName
    },
    /* 新增编辑usingKPI */
    saveUsing (param) {
      let vm = this
      let expressionName = vm.expressionName
      let KPIGroupId = vm.selectKpiGroup.id
      if (vm.addUsingKPITitle == '新增') {
        vm.$api.kpi.addMeasureUsingKPI3(JSON.stringify(param), KPIGroupId)
          .then((res) => {
            if (res.success) {
              vm.$message(res.errorStr)
              vm.usingAdd1 = false
              vm.getUsingKPIByGroupId()
            }
          })
      } else {
        if (vm.expressionName == '') {
          vm.$message.warning('表达式名称不能为空')
          return
        }
        vm.$api.kpi
          .modifyMeasureUsingKPI(vm.usingKpiId, expressionName, KPIGroupId)
          .then((res) => {
            if (res.success) {
              vm.getUsingKPIByGroupId()
              vm.usingUp = false
              vm.$message(res.msg)
            }
          })
      }
    },
    /* 关闭测量点树 */
    close (type) {
      this.usingAdd1 = type
    },
    //删除
    usingDele (row) {
      let vm = this
      vm.$confirm('确认删除该记录,是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        vm.$api.kpi.deleteMeasureUsingKPI(row.id).then((res) => {
          if (res.success) {
            vm.getUsingKPIByGroupId()
            vm.usingAction = false
          }
        })
      })
    },
    //关闭kpi分组弹窗
    formClosekpiGroup () {
      this.$refs['kpiGroupForm'].resetFields()
      this.kpiGroupForm = {
        name: '', //姓名
        displayName: '',
        id: '',
      }
    },
    handleCurrentChangeFl (row) {
      //kpi选择行
      let vm = this
      row = isNull(row) ? {} : row
      if (Object.keys(row).length > 0) {
        vm.selectKpi = row
        vm.selectKpiValue = row
      }
    },
    //查询kpi表格数据
    getKPI2 (id) {
      let vm = this
      let tableData = []
      vm.$api.kpi.getKPI2(id).then((res) => {
        if (res) {
          let kpiData = res.data
          let apiArr = []
          let eleArr = []
          for (let index = 0; index < kpiData.length; index++) {
            const element = kpiData[index]
            eleArr.push({
              id: element.id,
              name: element.name,
              displayName: element.displayName,
            })
            apiArr.push(vm.$api.kpi.getKPIValue2(element.id))
          }
          //获取kpi value 值11111111
          Promise.all(apiArr).then((resArr) => {
            for (let i = 0; i < resArr.length; i++) {
              let obj = resArr[i]
              if (obj) {
                if (obj.data.length > 0) {
                  for (let j = 0; j < obj.data.length; j++) {
                    const paramData = obj.data[j]
                    let item = JSON.parse(JSON.stringify(eleArr[i]))
                    item.kpiId = paramData.id
                    item.upperBound = paramData.upperBound
                    item.lowerBound = paramData.lowerBound
                    item.startTime = paramData.startTime
                    item.endTime = paramData.endTime
                    item.rowspan = j < 1 ? obj.data.length : 0
                    item.colspan = j < 1 ? 1 : 0
                    tableData.push(item)
                  }
                } else {
                  let item = eleArr[i]
                  item.rowspan = 1
                  item.colspan = 1
                  tableData.push(item)
                }
              }
            }
            if (tableData.length > 0) {
              vm.$refs.kpiData.setCurrentRow(tableData[0]) //选中第一行 新的
            }
            vm.kpiData = tableData
          })
        }
      })
    },
    addKPI (type) {
      //新增编辑api
      let vm = this
      vm.kpiForm.name = ''
      vm.kpiForm.displayName = ''
      if (type == 'add') {
        vm.titleKpi = '新增kpi'
      } else {
        if (Object.keys(vm.selectKpi).length == 0) {
          vm.$message({
            message: '请选择你要编辑的kpi！',
            type: 'warning',
          })
          return
        }
        vm.titleKpi = '编辑kpi'
        vm.kpiForm.name = vm.selectKpi.name
        vm.kpiForm.displayName = vm.selectKpi.displayName
      }
      vm.kpiDig = true
    },
    //kpi新增编辑保存
    saveKpi () {
      let vm = this
      vm.$refs['kpiForm'].validate((valid) => {
        if (valid) {
          let backres
          if (vm.titleKpi == '新增kpi') {
            backres = vm.$api.kpi.addKPI(
              vm.selectKpiGroup.id,
              vm.kpiForm.name,
              vm.kpiForm.displayName
            )
          } else {
            backres = vm.$api.kpi.modifyKPI(
              vm.selectKpi.id,
              vm.kpiForm.name,
              vm.kpiForm.displayName
            )
          }
          backres
            .then((res) => {
              if (res.success) {
                if (vm.titleKpi == '新增kpi') {
                  vm.$message.success('新增成功！')
                } else {
                  vm.$message.success(res.msg)
                }
                vm.getKPI2(vm.selectKpiGroup.id)
                this.kpiDig = false
              } else {
                return
              }
            })
            .catch((error) => {
              vm.$message.error(error.data.errorStr)
            })
        } else {
          return false
        }
      })
    },
    //删除kpi
    deleteKPI () {
      let vm = this
      if (Object.keys(vm.selectKpi).length == 0) {
        vm.$message({
          message: '请选择你要删除的kpi！',
          type: 'warning',
        })
        return
      }
      vm.$confirm('确认删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          vm.$api.kpi.deleteKPI(vm.selectKpi.id).then((res) => {
            if (res.success) {
              vm.getKPI2(vm.selectKpiGroup.id) ////
              vm.selectKpi = {}
              vm.$message.success(res.msg)
            }
          })
        })
        .catch((error) => {
          vm.$message.error(error.data.msg)
        })
    },
    //kpi 弹窗关闭
    formClosekpi () {
      this.$refs['kpiForm'].resetFields()
      this.kpiForm = {
        name: '',
        displayName: '',
        id: '',
      }
    },
    //新增编辑kpi value值
    addKPIValue (type) {
      let vm = this
      vm.kpiValueForm = {
        value: '',
        upperBound: '',
        lowerBound: '',
        startTime: '',
        endTime: '',
        id: '',
      }
      vm.search.dates = ['', '']
      if (type == 'add') {
        vm.titleKpiValue = '新增kpi value'
      } else {
        if (Object.keys(vm.selectKpiValue).length == 0) {
          vm.$message({
            message: '请选择你要编辑的kpi！',
            type: 'warning',
          })
          return
        }
        if (!vm.selectKpiValue.kpiId) {
          vm.$message({
            message: '请先添加KPI Vlaue再进行编辑！',
            type: 'warning',
          })
          return
        }
        console.log(vm.selectKpiValue)
        vm.search.dates[0] = vm.selectKpiValue.startTime ? vm.selectKpiValue.startTime : ''
        vm.search.dates[1] = vm.selectKpiValue.endTime ? vm.selectKpiValue.endTime : ''
        vm.titleKpiValue = '编辑kpi value'
        vm.kpiValueForm.upperBound = vm.selectKpiValue.upperBound
        vm.kpiValueForm.lowerBound = vm.selectKpiValue.lowerBound
      }
      vm.kpiValueDig = true
    },
    //kpiValue新增编辑保存
    saveKpiValue () {
      let vm = this
      let startDate = ''
      let endDate = ''
      console.log(vm.search)
      if (vm.search.dates) {
        console.log()
        if ((vm.search.dates[0] != '')) {
          console.log(111)
          startDate = dateTool.format(
            new Date(vm.search.dates[0]),
            'yyyy-MM-dd hh:mm:ss'
          )
        }
        if ((vm.search.dates[1] != '')) {
          endDate = dateTool.format(
            new Date(vm.search.dates[1]),
            'yyyy-MM-dd hh:mm:ss'
          )
        }
      }
      vm.$refs['kpiValueForm'].validate((valid) => {
        if (valid) {
          let backres
          if (vm.titleKpiValue == '新增kpi value') {
            backres = vm.$api.kpi.addKPIValue(
              vm.selectKpi.id,
              startDate,
              endDate,
              vm.kpiValueForm.upperBound,
              vm.kpiValueForm.lowerBound,
            )
          } else {
            backres = vm.$api.kpi.modifyKPIValue(
              vm.selectKpiValue.kpiId,
              startDate,
              endDate,
              vm.kpiValueForm.upperBound,
              vm.kpiValueForm.lowerBound,
            )
          }
          backres
            .then((res) => {
              if (res.success) {
                if (vm.titleKpiValue == '新增kpi value') {
                  vm.$message.success('新增成功！')
                } else {
                  vm.$message.success(res.msg)
                }
                vm.getKPI2(vm.selectKpiGroup.id)
                this.kpiValueDig = false
              } else {
                return
              }
            })
            .catch((error) => {
              vm.$message.error(error.data.msg)
            })
        } else {
          return false
        }
      })
    },
    //删除kpiValue
    deleteKPIValue () {
      let vm = this
      if (isUndefined(vm.selectKpiValue.kpiId)) {
        vm.$message({
          message: '该KPI下不存在KPI Value！',
          type: 'warning',
        })
        return
      }
      if (Object.keys(vm.selectKpiValue).length == 0) {
        vm.$message({
          message: '请选择你要删除的kpi value！',
          type: 'warning',
        })
        return
      } else {
        vm.$confirm('确认删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            vm.$api.kpi.deleteKPIValue(vm.selectKpiValue.kpiId).then((res) => {
              if (res.success) {
                vm.getKPI2(vm.selectKpiGroup.id) ////
                vm.selectKpiValue = {}
                vm.$message.success(res.msg)
              }
            })
          })
          .catch((error) => {
            //删除失败跟取消删除都会触发这个方法
            vm.$message.error(error.data.msg)
          })
      }
    },
    //kpi value弹窗关闭
    formClosekpiValue () {
      this.$refs['kpiValueForm'].resetFields()
    },
    tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
      //改表头颜色
      if (rowIndex === 0) {
        return 'background-color: #dbdbdb;color: #666;'
      }
    },
    /**
     *  合并行
     */
    arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex < 2) {
        //前三列合并
        return {
          rowspan: row.rowspan,
          colspan: row.colspan,
        }
      } else {
        return {
          rowspan: 1,
          colspan: 1,
        }
      }
    },
  },
}
</script>
<style lang="css" scoped>
.nc >>> .el-form-item__error--inline {
  /* position: relative; */
  top: auto;
  left: auto;
  display: inline-block;
  margin-left: 10px;
}
.boxOne >>> .el-form-item__error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 0;
  padding-top: 4px;
  position: absolute;
  top: 50px;
  left: 0;
}
</style>
<style lang="scss" scoped>
.boxOne {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 20px;
  box-sizing: border-box;
}
.el-dialog__footer >>> .el-dialog__footer {
  text-align: center !important;
}
.pagebox {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
}
.relative {
  position: relative;
}
.time_box {
  width: 100%;
}
.contant_box {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 20px;
  right: 20px;
}
.flexwrap {
  display: flex;
  flex-wrap: wrap;
}
.topitems {
  height: 100%;
  width: 100%;
  text-align: left;
}
.bottomitems {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 100px;
  padding: 5px;
  box-sizing: border-box;
}
.flex {
  display: flex;
  flex-flow: row;
  width: 100%;
  height: 100%;
}
.relative {
  position: relative;
}
.items {
  border: 1px solid #ccc;
  display: flex;
  flex-flow: column;
  flex: 2;
  margin-right: 20px;
}
.items1 {
  width: 10%;
  height: 99%;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.items2 {
  border: 1px solid #ccc;
  display: flex;
  flex-flow: column;
  flex: 3;
}
.tablebox {
  padding: 14px;
  box-sizing: border-box;
  //   background: #fff;
  display: flex;
  flex: 1;
}
.tbbox {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.btnbox {
  padding: 14px;
  box-sizing: border-box;
  //   background: #fff;
  .el-form-item {
    margin-bottom: 0;
  }
}
.tbbox > div {
  height: 100% !important;
}
.tablebox > div {
  overflow: hidden;
  height: 100% !important;
}
.treewindow {
  width: 100%;
  height: 450px;
  overflow: hidden;
  padding: 5px;
  box-shadow: border-box;
}
.body_item {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
}
.left_tree {
  width: 250px;
  height: 100%;
  overflow: hidden;
  border: 1px solid #ccc;
  margin-right: 10px;
  box-sizing: border-box;
}
.left_tree > div {
  height: 100% !important;
}
.right_table {
  flex: 1;
  height: 100%;
  border: 1px solid #ccc;
  box-sizing: border-box;
}
.right_table div {
  height: 100% !important;
}
.nc {
  // height: 50px;
}
.nc .el-input {
  width: 200px !important;
}
.usingItem {
  width: 250px;
  margin-left: 10px;
}
.usingTitle {
  width: 130px;
  display: inline-block;
  text-align: right;
}
</style>


